<div class="your-list-claim">
  <header>
    <mat-radio-group [(ngModel)]="status" (change)="changeStatus()" aria-label="Select an option">
      <mat-radio-button> <span class="claim-text" >{{'All Claims' | translate}}</span></mat-radio-button>
      <mat-radio-button value="active"> <span class="claim-text" >{{'Active Claims' | translate}}</span></mat-radio-button>
      <mat-radio-button value="inactive"> <span class="claim-text" >{{'Inactive Claims' | translate}}</span></mat-radio-button>
    </mat-radio-group>
  </header>

  <section *ngIf="claimsToShow">
    <ng-container *ngFor="let claim of claimsToShow">
      <app-block-claim [claim]="claim"></app-block-claim>
    </ng-container>
  </section>
</div>
